import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			} else if (selecionado == '/empresa' || selecionado == '/fornecedor' || selecionado == '/exame'
				|| selecionado == '/grupoFaturamento') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Lançamentos' icon='fas fa-money-check-alt' active={selecionado == '/'} />
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
